<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid class="pt-0">
                <div class="py-5">
                    <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">{{ ordDetail.goodsClsfNm }}</span>{{ordDetail.goodsNm}}</div>
                    <div class="secondary--text mt-2">{{ ordDetail.goodsDscrt}}</div>
                    <div class="fs-16 fw-700 primary--text line-height-1 mt-6">{{ ordDetail.paymentAmt + '원' | comma}}</div>
                </div>
                <hr class="hr"/>
                <div class="py-9">
                    <v-form class="form-item" v-model="valid">
                        <label class="label">구매 취소 사유</label>
                    <div class="input-group">
                        <v-text-field append-icon="mdi-menu-down" solo flat filled v-model="selectItem" readonly
                            placeholder="구매 취소 사유을 선택해주세요" @click="rollerPickerOpen" />
                    </div>
                    <v-textarea
                        filled
                        solo
                        flat
                        background-color="#F7F7F7"
                        no-resize
                        placeholder="구매 취소 사유를 입력해주세요."
                        class="pa-0 textarea"
                        style="margin-top: -18px;"
                        v-model="cancelMemo"
                        v-if="selectItem==='기타'"
                    ></v-textarea>
                    </v-form>

                </div>
            </v-container>
            <div class="footer-btns">
                <BlackBtn str="구매 취소하기" @click="orderCancel"/>
            </div>
        </v-layout>
        <SelectRollerPicker ref="rollerPicker" @selectValue="selectValue" :disabled="true"/>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import SelectRollerPicker from "@/components/layout/bottomSheet/SelectRollerPicker";
import store from '@/store'

export default {
    data: () => ({
        valid: false,
        name: '',
        phone: '',
        address: '',
        addressDetails: '',
        items: ['상품이 마음에 들지않음 (단순변심)', '상품변경', '상품가격이 비쌈', '생각보다 이용을 하지 않음', '기타'],
        selectItem: '',
        ordDetail: {
            goodsClsfNm : ''
        },
        cancelMemo: '',
        isDisabled:true
    }),
    components: {
        BlackBtn,
        SelectRollerPicker,
    },
    created(){
        this.orderDetail();
    }
    ,
    watch:{
        selectItem(){
            if(this.selectItem !== null){
                this.isDisabled = false;
            }
        }
    },
    methods: {
        rollerPickerOpen(){
            this.$refs.rollerPicker.setFlicking(this.items);
        },
        selectValue (value){
           this.selectItem = value;
        },
        async orderCancel(){
            let po  = this.ordDetail;

            switch(this.selectItem){
                case '상품이 마음에 들지않음 (단순변심)':
                po.ordCancelRsonCd = '01';
                break;
                case '상품변경':
                po.ordCancelRsonCd = '02';
                break;
                case '상품가격이 비쌈':
                po.ordCancelRsonCd = '03';
                break;
                case '생각보다 이용을 하지 않음':
                po.ordCancelRsonCd = '04';
                break;
                case '기타':
                po.ordCancelRsonCd = '05';
                break;
            }
            po.ordCancelRsonMemo = this.cancelMemo;

            if(po.ordCancelRsonCd === '05' && po.ordCancelRsonMemo===""){
                this.$alert("취소사유를 입력해 주세요.");
                return false;
            }
            let url = "orderCancel"

            if(po.rtEp > 1 && po.goodsClsfNm === "티켓"){
                url = "orderPartialCancel"

            }
            await store.dispatch(url, this.$_payload('po', po))
            .then(res => {
                console.log(res)
                this.movePage('/fo/purchase/history');
                this.$root.$children[0].$refs.toast.toastOpen('top','구매가 취소되었습니다.');

            })
            .catch(error => {
                console.error(error)

            })
            .finally(() => {

            })
        },
        async orderDetail(){
            await store.dispatch('orderDetail', this.$_payload({ordNo:this.$route.query.ordNo}))
            .then(res => {
               console.log(res);
               this.ordDetail = res.data;
            })
            .catch(error => {
                console.error(error)

            })
            .finally(() => {

            })
        },
    }
    ,filters:{
        comma(val){
            return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
}
</script>
<style lang="scss" scoped>
.badge {
    border: 1px solid $color-main;
    padding: 0 10px;
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    color: $color-main;
    background: transparent;
    border-radius: 20px;
    width: auto;
    flex-shrink: 0;
}
</style>
